import { signIn, useAuth } from "../auth";
import { useSyncStatus, type SyncStatus } from "../sync/engine";
import { signOutAndClear } from "../sync";

const STATUS: Record<SyncStatus, { label: string; dot: string } | null> = {
  off: null,
  syncing: { label: "Saving…", dot: "bg-muted animate-pulse" },
  synced: { label: "Saved", dot: "bg-station" },
  offline: { label: "Offline", dot: "bg-handover" },
  error: { label: "Not saved", dot: "bg-danger" },
};

export function AccountMenu() {
  const { status, email, error } = useAuth();
  const sync = useSyncStatus();

  if (status === "unavailable") return null;
  if (status === "loading") return <span className="text-sm text-muted">Loading…</span>;

  if (status === "signed-out") {
    return (
      <div className="flex items-center gap-3">
        {error && (
          <span role="alert" className="text-sm text-danger">
            {error}
          </span>
        )}
        <span className="hidden text-sm text-muted md:inline">Sync plans across devices</span>
        <button type="button" className="btn" onClick={() => void signIn()}>
          Sign in
        </button>
      </div>
    );
  }

  const indicator = STATUS[sync.status];
  return (
    <div className="flex min-w-0 items-center gap-3">
      {indicator && (
        <span
          className="flex items-center gap-1.5 text-xs text-ink-2"
          title={sync.message ?? undefined}
          role="status"
        >
          <span aria-hidden className={`size-2 rounded-full ${indicator.dot}`} />
          {indicator.label}
        </span>
      )}
      <span className="hidden max-w-48 truncate text-sm text-ink-2 sm:inline" title={email ?? ""}>
        {email}
      </span>
      <button type="button" className="btn" onClick={() => void signOutAndClear()}>
        Sign out
      </button>
    </div>
  );
}
